module.exports = __webpack_public_path__ + "img/sedan_parked.f37b6092.svg";